import { render, staticRenderFns } from "./risk-icons.vue?vue&type=template&id=b94423b2&"
import script from "./risk-icons.vue?vue&type=script&lang=js&"
export * from "./risk-icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports